import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType, OnInitEffects } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { IAppState } from '@shared/store/models';
import { debounceTime, distinctUntilChanged, map, switchMap, tap } from 'rxjs/operators';
import * as HydrationActions from './hydration.actions';

@Injectable()
export class HydrationEffects implements OnInitEffects {
  private readonly action$ = inject(Actions);
  private readonly store = inject<Store<IAppState>>(Store);

  hydrate$ = createEffect(() =>
    this.action$.pipe(
      ofType(HydrationActions.hydrate),
      map(() => {
        const storageValue = localStorage.getItem('state');
        if (storageValue) {
          try {
            const state: IAppState = JSON.parse(storageValue);
            return HydrationActions.hydrateSuccess({
              // only rehydrate this part of the state
              state: {
                ...(state.locations && { locations: state.locations }),
                ...(state.session && {
                  session: {
                    sessionData: { ...state.session.sessionData, notification: null },
                    login: state.session.login,
                    userFilterOptions: state.session.userFilterOptions,
                  },
                }),
                ...(state.chargingInfrastructure && {
                  chargingInfrastructure: {
                    ...(state.chargingInfrastructure.expertView && {
                      expertView: {
                        selectedWorkspaceId:
                          state.chargingInfrastructure.expertView.selectedWorkspaceId,
                        selectedWorkspace:
                          state.chargingInfrastructure.expertView.selectedWorkspace,
                        modifiedWorkspaces:
                          state.chargingInfrastructure.expertView.modifiedWorkspaces,
                      },
                    }),
                  } as any,
                }),
              },
            });
          } catch {
            localStorage.removeItem('state');
          }
        }
        return HydrationActions.hydrateFailure();
      })
    )
  );

  serialize$ = createEffect(
    () =>
      this.action$.pipe(
        ofType(HydrationActions.hydrateSuccess, HydrationActions.hydrateFailure),
        switchMap(() => this.store),
        distinctUntilChanged(),
        debounceTime(500),
        tap(state => {
          localStorage.setItem('state', JSON.stringify(state));
        })
      ),
    { dispatch: false }
  );

  ngrxOnInitEffects(): Action {
    return HydrationActions.hydrate();
  }
}
